import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

	 dataFails = 'data fails' ; dataSuccess = 'data success'
	contentType = 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15' ;

  constructor(private readonly http : HttpClient) { }

  getUserDetails(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/getusers`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
  }



  getUserInfo(toyotaGUID): Observable<any> {
	const httpCustomOptions = {
		headers: new HttpHeaders({
			'Content-Type': this.contentType,
			'Accept': 'application/json',
		})
	};
	return this.http
	// ${toyotaGUID}
		.get(`${environment.baseAPIURL}/api/v1/getuserinfo/${toyotaGUID}`, httpCustomOptions)
		.pipe(
			tap(_ => this.log(this.dataSuccess)),
			catchError(this.handleError<any>(this.dataFails))
		);
}



  // multiselect region dropdown - add this service in boards service ..
  getRegionDetails(): Observable<any> {
	const httpCustomOptions = {
		headers: new HttpHeaders({
			'Content-Type': this.contentType,
			'Accept': 'application/json',
		})
	};
	return this.http
		.get(`${environment.baseAPIURL}/api/v1/regions`, httpCustomOptions)
		.pipe(
			tap(_ => this.log(this.dataSuccess)),
			catchError(this.handleError<any>(this.dataFails))
		);
}

  

	private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}


}
